module.exports = __webpack_public_path__ + "static/sandwich-893b3bc19dd69740536943a04915cffd.jpg";